// Settings getters
/* eslint-disable */
import i18n from '@/i18n';

export default {
  get_admin_settings: (state) => state.adminSettings,
  get_payers: (state) => state.payers,
  get_payer_by_id: (state) => (id) => state.payers.items.filter((payer) => payer.id === id)[0],
  get_payer_select: (state) => state.payers.items.map((opt) => {
    return{
      text: opt.name, value: opt.id
    }
  }),
  get_payer_carriers: (state) => state.payerCarriers,
  get_payer_carrier_by_id: (state) => (id) => state.payerCarriers.items.filter((action) => action.id === id)[0],
  get_senders: (state) => state.senders,
  get_senders_options: (state) => state.senders.items.map(sender => {
    return {
      text: sender.company_name ? sender.company_name : sender.name,
      value: sender.id,
    }
  }),
  get_sender_by_id: (state) => (id) => state.senders.items.filter((sender) => sender.id === id)[0],
  get_printers: (state) => state.printers,
  get_printer_by_id: (state) => (id) => state.printers.items.filter((printer) => printer.id === id)[0],
  get_packages: (state) => state.packages,
  get_package_by_id: (state) => (id) => state.packages.items.filter((packages) => packages.id === id)[0],
  get_users: (state) => state.users,
  get_stored_user: (state) => state.user, //this is not logged user.. use get_user getter if you want logged user!!!
  get_user_by_id: (state) => (id) => state.users.items.filter((user) => user.id === id)[0],
  get_user_permissions: (state) => state.userPermissions,
  get_user_permission: (state) => (name) => state.userPermissions.filter((permission) => permission.acl_route_group == name)[0],
  get_wall_news: (state) => state.wall_news,
  get_unread_wall_news_count: (state) => state.wall_news?.entity?.total_unread,
  get_smtps: (state) => state.smtps,
  get_smtps_options: (state) => state.smtps.items.map(smtp => {
    return {
      text: smtp.name,
      value: smtp.id_and_type,
    }
  }),
  get_all_smtps_options: (state) => state.allSmtps.map(smtp => {
    return {
      text: smtp.name,
      value: smtp.id_and_type,
    }
  }),
  get_smtp_by_id: (state) => (id) => state.smtps.items.filter((smtp) => smtp.id === id)[0],
  get_systems: (state) => state.systems,
  get_system_by_id: (state) => (id) => state.systems.items.filter((system) => system.id === id)[0],
  get_notifications: (state) => state.notifications,
  get_active_notification: (state) => state.notification,
  get_notification_by_id: (state) => (id) => state.notifications.items.filter((notification) => notification.id === id)[0],
  get_automations: (state) => state.automations,
  get_automation: (state) => state.automation.items,
  get_automation_entity: (state) => state.automation.entity,
  get_automation_actions: (state) => state.automationActions,
  get_automation_action_by_id: (state) => (id) => state.automationActions.items.filter((action) => action.id === id)[0],
  get_all_packaging_options: (state) => {
    let array = [];
    const obj = state.allPackagingOptions;
    for (const [val, name] of Object.entries(obj)) {
      array.push({text: name, value: val})
    }
    return array;
  },
  get_templates: (state) => state.templates,
  get_template_field: (state) => (opt) => {
    const optArray = [];
    for (const property in state.templates.entity[0][opt]) {
      optArray.push({
        text: property,
        value: state.templates.entity[0][opt][property],
      })
    }
    return optArray;
  },
  get_available_fields: (state) => (opt) => {
    return state.templates.entity[0][opt].filter((field) => {
      return !field.required;
    }).map((field) => {
      return {
        text: field.field,
        value: field.value,
        isVisible: false,
      };
    });
  },
  get_template_by_id: (state) => (id) => state.templates.items.filter((template) => template.id === id)[0],
  get_upload_progress: (state) => state.uploadProgress,
  get_label_printers: (state) => {
    return [{text: i18n.t('Show label in popup'), value: '0'}, ...state.label_printers.map(opt => {
      return {text: opt.name, value: opt.id};
    })];
  },
  get_document_printers: (state) => {
    return [{text: i18n.t('Print from browser'), value: '0'}, ...state.document_printers.map(opt => {
      return {text: opt.name, value: opt.id};
    })];
  },
  get_label_formats: (state) => state.label_formats,
  get_location_shippers: (state) => {
    return state.shippers.map(opt => {
      return {text: opt.name, value: opt.id};
    });
  },
  get_document_packages_available: (state) => {
    return [{text: 'Custom dimensions', value: 0}, ...state.document_packages_available.map(opt => {
      return {text: opt.name, value: opt.id};
    })];
  },
  get_parcel_packages_available: (state) => {
    return [{text: 'Custom dimensions', value: 0}, ...state.parcel_packages_available.map(opt => {
      return {text: opt.name, value: opt.id};
    })];
  },
  get_pallet_packages_available: (state) => {
    return [{text: 'Custom dimensions', value: 0}, ...state.pallet_packages_available.map(opt => {
      return {text: opt.name, value: opt.id};
    })];
  },
  get_load_packages_available: (state) => {
    return [{text: 'Custom dimensions', value: 0}, ...state.load_packages_available.map(opt => {
      return {text: opt.name, value: opt.id};
    })];
  },
  get_user_available_currencies: (state) => {
    return [...state.currencies.map(opt => {
      return {text: opt.value, value: opt.value};
    })];
  },
  get_user_currency_by_value: (state) => (opt) => {
    let currencies = _.cloneDeep(state.currencies);
    return currencies.filter((obj) => {
      return obj.value = opt
    })[0];
  },
  get_goods_types: (state) => {
    return state.goods_types.map(opt => {
      return {text: opt.name, value: opt.id};
    });
  },
  get_goods_type_options: (state) => {
    return [
      {text: 'parcel', value: 1},
      {text: 'document', value: 2},
      {text: 'pallet', value: 3},
      {text: 'load', value: 4},
    ];
  },
  get_return_waybill_action_types: (state) => {
    return  state.return_waybill_action_types.map((o) => {
      return {text: o.text, value: o.value};
    })
  },
  get_carrier_account: (state) => state.carrierAccount,
  get_carrier_accounts: (state) => state.carrierAccounts,
  get_carrier_account_by_id: (state) => (id) => state.carrierAccounts.items.filter((carrier_accounts) => carrier_accounts.id === id)[0],
  get_carrier_accounts_by_shipping_agent_id: (state) => (id) => state.carrierAccounts?.items?.length ? state.carrierAccounts.items.filter((carrier_accounts) => parseInt(carrier_accounts.shipping_agent_id) === parseInt(id)) : [],
  get_shipping_agents: (state) => state.shippingAgents,
  get_shipping_agents_select: (state) => state.shippingAgents.map((opt) => {
    return{
      text: opt.name, value: opt.id
    }
  }),
  get_company_available_shipping_agents_select: (state) => state.companyAvailableShippingAgents.map((opt) => {
    return{
      text: opt.name, value: String(opt.id)
    }
  }),
  get_company_available_shipping_products_select: (state) => state.companyAvailableShippingProducts.map((opt) => {
    return{
      text: opt.shipping_agent ? `${opt.shipping_agent} - ${opt.product_name}` : opt.product_name,
      value: String(opt.id)
    }
  }),
  get_integrations: (state) => state.integrationsByCarrier.map((opt) => {
    return{
      text: opt.name, value: opt.id
    }
  }),
  get_integration_params: (state) => state.integrationParams,
  get_integration_params_barcode: (state) => {
    return [].concat.apply([], state.integrationParams.barcode);
  },
  get_carrier_account_products: (state) => state.carrierAccountProducts,
  get_carrier_account_product_by_id: (state) => (id) => state.carrierAccountProduct.filter((carrier_accounts) => carrier_accounts.id === id)[0],
  get_account_consignor: (state) => state.accountConsignor,
  get_account_danske_codes: (state) => state.accountDanskeCodes.items,
  get_account_danske_entity: (state) => state.accountDanskeCodes.entity,
  get_account_danske_code_by_id: (state) => (id) => state.accountDanskeCodes.items.filter((codes) => codes.id === id)[0],
  get_account_danske_code_types: (state) => {
    let array = [];
    const obj = state.accountDanskeCodes.entity.types;
    for (const [val, name] of Object.entries(obj)) {
      array.push({text: name, value: val})
    }
    return array;
  },
  get_ftp_settings: (state) => state.ftpSettings,
  get_ftp_setting_by_id: (state) => (id) => state.ftpSettings.items.filter((ftpSetting) => ftpSetting.id === id)[0],
};
